const queryInitials = [
  {
    name: 'domain',
    initial: '='
  },
  {
    name: 'path',
    initial: '='
  },
  {
    name: 'query',
    initial: 'EMPTY'

  },
  {
    name: 'hash',
    initial: 'EMPTY'
  },
  {
    name: 'name',
    initial: 'EMPTY',
    case: 'sensitive'
  }
];

export default queryInitials;



/** WEBPACK FOOTER **
 ** ./src/constants/queryInitials.js
 **/